import { Injectable } from '@angular/core';

import { EventOption } from '@frontend/sports/betting-offer/feature/model';

@Injectable({ providedIn: 'root' })
export class OptionNameStrategy {
    getOptionName(option: EventOption): string {
        return option.name;
    }
}
